// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hboK","select":"styles_select__3ieRb"};